<template>
  <page-template>
    <template #title>Chords</template>
    <template #type>
      <app-drop-down-menu setting="type"
                          :options="types"
                          text="Type: "
                          :currently-selected="type"
                          @updated="setState"
                          :small="true"/>
    </template>
    <template #search>
      <app-search @search="generate" @termChange="termChange"/>
    </template>
    <template #content>
      <div class="px-3 info lighten-2"
           :class="`${$vuetify.breakpoint.mdAndUp ?'body-1' : 'caption'}`">
        <chords-header/>
      </div>
      <v-expansion-panels>
        <chord-card v-for="(chord, i) in chords"
                    :key="i"
                    :pitch-classes="chord.pitchClasses"
                    :octave="getOctave"
                    :info="chord.info"
                    :index="i + pagination.pageStart"/>
      </v-expansion-panels>
      <v-col :cols="12" v-if="pagination.data().length === 0" class="display-1 blue--text">
        No chords Found!
      </v-col>
    </template>
    <template #pagination>
      <v-pagination circle color="primary" v-model="pagination.page"
                    :length="pagination.pages"/>
    </template>
    <template #help-title>Help</template>
    <template #help-text>
      Here you can browse different chords and listen to them and their inversions both melodically and harmonically.
      <br><br>
      To see the inversions of a chord simply press on a chord card and it will expand.
    </template>
  </page-template>
</template>

<script>
  import { mapGetters }                           from 'vuex'
  import Paginator                                from 'vue-paginator3k'
  import chordRef                                 from 'assets/json/chord-ref'
  import { setTransportBPM, setTransportLooping } from 'helpers/tone-helpers'
  import { createChord, getConstants }            from 'helpers/note-art-helpers'

  export default {
    name: 'Chords',

    head: {
      title: function() {
        return {
          inner: 'Chords',
        }
      },
      meta:  [
        {
          name:    'music theory chords',
          content: 'an interactive list of music chords to explore and play',
          id:      'desc',
        },
      ],
    },

    components: {
      PageTemplate:    () => import(/* webpackChunkName: "components" */ 'components/PageTemplate'),
      ChordsHeader:    () => import(/* webpackChunkName: "feature-sections" */ 'sections/app/cards/ChordsHeader'),
      ChordCard:       () => import(/* webpackChunkName: "feature-sections" */ 'sections/app/cards/ChordCard'),
      AppDropDownMenu: () => import(/* webpackChunkName: "components" */ 'components/AppDropDownMenu'),
      AppSearch:       () => import(/* webpackChunkName: "components" */ 'components/AppSearch'),
    },

    created() {
      setTransportBPM(120)
      setTransportLooping(false)
      this.generate()
    },

    data() {
      return {
        root:         'C',
        help:         false,
        pitchClasses: getConstants().pitchClasses,
        type:         'Major',
        types:        ['Major', 'Minor', 'Other', 'Search'],
        activeTab:    0,
        pagination:   new Paginator(7),
        term:         '',
      }
    },

    computed: {
      ...mapGetters('context', ['getPitch', 'getOctave']),
      chords() {
        return this.pagination.data().map(({ chord, name, pattern }) => createChord(this.getPitch, JSON.parse(pattern), {
          chord,
          name,
        }))
      },
    },

    methods: {
      generate() {
        let data
        if(this.type !== 'Search') {
          data = chordRef.filter(({ pattern }) => this.chordFilter(JSON.parse(pattern)))
        } else {
          data = chordRef.filter(chord => {
            return chord.name.toLowerCase().includes(this.term) || chord.chord.toLowerCase().includes(this.term)
          })
        }
        this.pagination.data(data)
      },
      chordFilter(pat) {
        if(this.type === 'Major') {
          return pat.includes(4)
        } else if(this.type === 'Minor') {
          return pat.includes(3)
        }
        return !(pat.includes(3) || pat.includes(4))
      },
      setState({ setting, value }) {
        this[setting] = value
        this.generate()
      },
      termChange(term) {
        this.term = term
        if(this.type !== 'Search') {
          this.type = 'Search'
        }
        if(term) {
          this.generate()
        }
      },
    },
  }
</script>
